var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found align align--center-column"},[_c('h2',{staticClass:"not-found__title"},[_vm._v("the page you're looking for can't be found")]),_c('h3',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("return home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }